/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.8.0-nightly.2026.10.24",
    versionName: "0.8.0-nightly.2026.10.24",
    versionChannel: "nightly",
    buildDate: "2026-10-24T00:14:33.905Z",
    commitHash: "159d7dbbca40bd475c8693df011b3dbf66213844",
};
